import React, { useEffect, useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import compare from "../images/compare.svg";
import wishlist from "../images/wishlist.svg";
import user from "../images/user.svg";
import cart from "../images/cart.svg";
import menu from "../images/menu.svg";
import homeLogo from "../images/homelogo1.png"
import LOGO from "../images/newShoplinticLogo.jpeg"
import { useDispatch, useSelector } from "react-redux";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { getAllCategory, getAllProducts, getAllProductsForSearch, getAProduct } from "../features/products/productSlilce";
import { getUserCart, getuserProductWishlist } from "../features/user/userSlice";
import { FeaturedArray, symbole } from "./commonData";
import { jwtDecode } from "jwt-decode";
import Slider from "react-slick";
import LoginSignUpModal from "../pages/LoginSignUpModal";
const NextArrow = ({ onClick, className, style }) => (
  <div
    className={`slick-arrow-next ${className || ''}`}
    onClick={onClick}
    style={style}
    aria-label="Next"
  >
    <img src="https://www.iconpacks.net/icons/2/free-arrow-right-icon-3098-thumb.png" alt="next" />
  </div>
);

const PrevArrow = ({ onClick, className, style }) => (
  <div
    className={`slick-arrow-prev ${className || ''}`}
    onClick={onClick}
    style={style}
    aria-label="Previous"
  >
    <img src="https://www.iconpacks.net/icons/2/free-arrow-left-icon-3099-thumb.png" alt="prev" />
  </div>
);

const Header = () => {
  const dispatch = useDispatch();
  const cartState = useSelector((state) => state?.auth?.cartProducts);
  const wishlistState = useSelector((state) => state?.auth?.wishlist?.wishlist);
  const authState = useSelector((state) => state?.auth);
  const [total, setTotal] = useState(null);
  const [mobileView,setMobileView]=useState(false)
   const productCategory = useSelector((state) => state?.product?.category.map((item)=>item));
  const [paginate, setPaginate] = useState(true);
  const [modal,setModal]=useState(false)
  const productState = useSelector((state) => state?.product?.productSearch) || [];
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
   const [selected, setSelected] = useState([]);
  const [input, setInput] = useState("");
  const categoryList=productState?.length > 0 ? productState?.map((item) => item.category)?.filter((v, i, a) => a.indexOf(v) === i) :[];
  const getTokenFromLocalStorage = localStorage.getItem("customer")
    ? JSON.parse(localStorage.getItem("customer"))
    : null;

  const config2 = {
    headers: {
      Authorization: `Bearer ${
        getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
      }`,
      Accept: "application/json",
    },
  };

const sliderSettings = {
  infinite: true,
  speed: 400,
  slidesToScroll: 1,
  swipeToSlide: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: false,

  responsive: [
    {
      breakpoint: 9999,
      settings: { slidesToShow: 5 },
    },
    {
      breakpoint: 992,
      settings: { slidesToShow: 4 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 3.2 },
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 2.6 },
    },
  ],
};


  useEffect(() => {
    dispatch(getUserCart(config2));
    dispatch(getuserProductWishlist(config2));
    dispatch(getAllCategory())
  }, []);

  const [productOpt, setProductOpt] = useState([]);
  useEffect(() => {
    let sum = 0;
    for (let index = 0; index < cartState?.length; index++) {
      sum = sum + Number(cartState[index].quantity) * cartState[index].price;
      setTotal(sum);
    }
  }, [cartState]);

useEffect(() => {
  let data = [];
  for (let index = 0; index < productState?.length; index++) {
    const element = productState[index];
    data.push({
      id: index,
      prod: element?._id,
      name: String(element?.title || "Not available"),
      category: String(element?.category || ""),
      category_slug: String(element?.category_slug || ""),
      tags: String(element?.tags || ""),
      description: String(element?.description || ""),
      element, // keep original safely
    });
  }
  setProductOpt(data);
}, [productState]);



  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };
  const nav=useNavigate()
  const navigateFun=(item)=>{
nav("/product",{state:{data:item}})
  }
    const normalize = (str) =>
    str?.toLowerCase().replace(/[_-]/g, " ").replace(/\s+/g, " ").trim() || "";

  const fuzzyMatch = (input, target) => {
    if (!input || !target) return false;
    // Simple fuzzy: Check all letters of input are somewhere in target in order
    let i = 0, j = 0;
    while (i < input.length && j < target.length) {
      if (input[i] === target[j]) i++;
      j++;
    }
    return i === input.length;
  };
useEffect(() => {

  if (getTokenFromLocalStorage?.token) {
    const token = getTokenFromLocalStorage.token;
    try {

      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000; // current time in seconds

      if (decoded.exp < currentTime) {
     setModal(true)
      }
    } catch (err) {
      console.error("Invalid token", err);
     
    }
  }
    dispatch(
    getAllProductsForSearch({
     category:"all"
    })
  );
}, []);
  return (
    <>
    {modal && <div className="modal active" tabindex="-1" role="dialog" style={{display:"block",background:"#9ebebcdb"}}>
  <div className="modal-dialog " role="document" style={{top:"30%"}}>
    <div className="modal-content">
   
      <div className="modal-body text-center text-align-center">
        <p>Session is Expired. Please Login !</p>
      </div>
      <div className="modal-footer d-flex justify-content-around border-top-0">
        <button type="button"  onClick={()=>{
           localStorage.clear();
          navigate("/");
       setModal(false)
        }} className="btn btn-primary">Login</button>
        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleLogout}>Cancel</button>
      </div>
    </div>
  </div>
</div>}
      {/* <header className="header-top-strip py-3" style={{maxWidth:"100vw"}}>
        <div className="container-xxl">
          <div className="row">
            <div className="col-6 col-md-4 col-sm-4">
              <p className="text-dark mb-0">Free Shipping</p>
            </div>
            <div className="col-6 col-md-8 col-sm-8">
              <p className="text-end text-dark mb-0">
                support:
                <a className="text-dark" href="tel:+91 8287049939">
                  dummy@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </header> */}
   <header className="header-upper py-0" style={{background:"#0053e2"}}>
  <div className="container-xxl mobile-size ">
    <div className="row align-items-center w-100 col-md-12 col-sm-12 hearder-search-logo">
      
      {/* Logo */}
      <div className="col-2 col-md-2 mb-2 mb-md-0 hide-on-mobile-view">
        <h2 className="mb-0 mr-4">
          <Link className="text-white" to="/">
            <img src={LOGO} alt="text" className="mt-2 rounded-3" style={{width:"150px",height:"100px"}} />
          </Link>
        </h2>
      </div>
       <div className="col-4 col-md-2 mb-2 mb-md-0 display-on-mobile-view">
        <h2 className="mb-0 mr-1">
          <Link className="text-white" to="/">
                  <img src={LOGO} alt="text" className="mt-2 rounded-3" style={{width:"60px"}} />
          </Link>
        </h2>
      </div>

      {/* Search Bar */}
      <div className="col-8 col-md-5 mb-2 mb-md-0">
        <div className="input-group">
<Typeahead
  id="product-search"
  options={productOpt}
  labelKey={(option) => option.name || option.title || ""} // Safe fallback
  onInputChange={(text) => setInput(text)}
  onChange={(sel) => {
        dispatch(
    getAllProductsForSearch({
     category:"all"
    })
  );
    if (sel.length > 0) {
      // If a product is selected
      navigate(`/product/${sel[0].prod}`);
      dispatch(getAProduct(sel[0].prod));
    }
  }}
  onKeyDown={(e) => {
    if (e.key === "Enter" && input.trim()) {
      const searchTerm = normalize(input);

      // First, try to match product
      const matchProduct = productOpt.find((opt) =>
        fuzzyMatch(searchTerm, normalize(opt.name || opt.title))
      );

      if (matchProduct) {
        navigate(`/product/${matchProduct.prod}`);
        dispatch(getAProduct(matchProduct.prod));
        return;
      }

      // Next, try to match category
      const matchCategory = productCategory.find((cat) =>
        fuzzyMatch(searchTerm, normalize(cat.title))
      );

      if (matchCategory) {
        navigate(`/product?category=${matchCategory.unique_slug}`);
        return;
      }
    }
  }}
  filterBy={(option, props) => {
    const term = normalize(props.text);
    return (
      fuzzyMatch(term, normalize(option.name || option.title)) ||
      fuzzyMatch(term, normalize(option.category)) ||
      fuzzyMatch(term, normalize(option.category_slug)) ||
      fuzzyMatch(term, normalize(option.tags)) ||
      fuzzyMatch(term, normalize(option.description))
    );
  }}
  placeholder="Search for products or categories..."
/>


          <span className="input-group-text p-0 px-2  p-md-3" id="basic-addon2" onClick={()=>{
             navigate(`/product?search=${input.trim().replace(/\s+/g, '+')}`);

          }} >
            <BsSearch className="fs-6" />
          </span>
        </div>
      </div>

      {/* Right Side Icons */}
      <div className="col-12 col-md-5 hide-on-mobile-view">
        <div className="logos-menue d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-end gap-3">

          {/* Wishlist */}
        {authState?.user ?   <Link to="/wishlist" className="d-flex align-items-center gap-2 text-white">
            <img src={wishlist} alt="wishlist" />
             <div className="d-flex flex-column gap-1">
              <span className="badge bg-white text-dark">
                {wishlistState?.length || 0}
              </span>
              {/* <p className="mb-0 d-none d-md-block">
              {symbole} {cartState?.length ? total : 0}
              </p> */}
            </div>
          </Link> :
          <div role="button" className="d-flex align-items-center gap-2 text-white"  data-bs-toggle="modal"
        data-bs-target="#loginSignUpModal">
            <img src={wishlist} alt="wishlist" />
              <div className="d-flex flex-column gap-1">
              <span className="badge bg-white text-dark">
                {0}
              </span>
              {/* <p className="mb-0 d-none d-md-block">
              {symbole} {0}
              </p> */}
            </div>
          </div>
          
          }

          {/* Cart */}
     { authState?.user ?     <Link to="/cart" className="d-flex align-items-center gap-2 text-white">
            <img src={cart} alt="cart" />
            <div className="d-flex flex-column gap-1">
              <span className="badge bg-white text-dark">
                {cartState?.length || 0}
              </span>
              {/* <p className="mb-0 d-none d-md-block">
              {symbole} {cartState?.length ? total : 0}
              </p> */}
            </div>
          </Link> :   <div role="button" className="d-flex align-items-center gap-2 text-white"  data-bs-toggle="modal"
        data-bs-target="#loginSignUpModal">
            
            <img src={cart} alt="cart" /> 
            <div className="d-flex flex-column gap-1">
              <span className="badge bg-white text-dark">
                {0}
              </span>
              {/* <p className="mb-0 d-none d-md-block">
              {symbole} {0}
              </p> */}
            </div>
          </div> } 

          {/* User */}
          <div className="user-menu position-relative">
            <div className="d-flex align-items-center gap-2 text-white user-icon">
              <img src={user} alt="user" />
              <p className="mb-0 d-none d-md-block">
                {authState?.user ? `Welcome ${authState.user.firstname}` : <a  data-bs-toggle="modal"
  data-bs-target="#loginSignUpModal" className="text-white text-decoration-none">Login</a>}
                <br />
               {authState?.user && "My Account"}
              </p>
            </div>
           {authState?.user && <div className="dropdown-menu">
              {authState?.user && (
                <>
                  <Link to="/my-profile" className="dropdown-item">
                    My Profile
                  </Link>
                  <Link to="/my-orders" className="dropdown-item">
                    My Order
                  </Link>
                  <button className="dropdown-item" onClick={handleLogout}>
                    Logout
                  </button>
                </>
              ) }
            </div>}
          </div>

        </div>
      </div>

    </div>
  </div>
</header>

    <header className="header-bottom py-3 text-white hide-on-mobile-view" style={{background:"#0053e2"}}>
  <div className="container-xxl">
    <div className="row">
      <div className="col-12">
        <div className="menu-bottom d-flex flex-column  flex-md-row align-items-start align-items-md-center gap-3 gap-md-5">
          
          {/* Dropdown for Categories */}
          <div className="menu-header-medium w-md-100 d-flex justify-content-between justify-content-md-between ">
            <div className="dropdown">
              <button
                className="btn btn-outline-light dropdown-toggle d-md-flex align-items-md-center w-30"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img src={menu} alt="menu" className="me-2" />
                <span>Shop Categories</span>
              </button>
              <ul className="dropdown-menu dropdown-menu-dark w-100 mt-2" aria-labelledby="dropdownMenuButton1">
                {productCategory &&
                  productCategory.map((item, index) => (
                    <li key={index}>
                      <a className="dropdown-item" href={`/product?category=${item?.unique_slug}`}>
                        {item.title}
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
{/* <div className="d-md-none d-none mt-3" onClick={()=>setMobileView(!mobileView)} >   <img src={menu} alt="menu" className="me-2" /></div> */}
            
          </div>

          {/* Featured Nav Links */}
          <div className="w-75 menu-links d-none d-md-block">
            <div className="d-flex flex-wrap align-items-center gap-3">
              {productCategory.length > 0 &&
                productCategory.map((item, index) => (
                  <a
                    key={index}
                    className="text-white text-decoration-none"
                    href={`/product?category=${item?.unique_slug}`}
                  >
                    {item.title}
                  </a>
                ))}
            </div>
          </div>
          {/* For Mobile - Collapsed Links */}
     {mobileView &&     <div className="d-md-none mt-3">
            <div className="d-flex flex-column gap-2">
              {productCategory.length > 0 &&
                productCategory.map((item, index) => (
                  <a
                    key={index}
                    className="btn btn-outline-light w-100"
                    href={`/product?category=${item?.unique_slug}`}
                  >
                    {item.title}
                  </a>
                ))}
            </div>
          </div>}

        </div>
      </div>
    </div>
  </div>
</header>
<div className="category-bar" style={{background:"#f16da2",padding:"10px 0"}}>
  <Slider {...sliderSettings}>
    {productCategory.map((cat) => (
      <div key={cat.id} className="category-slide p-0">
        <a
          href={`/product?category=${cat.unique_slug}`}
          className="category-pill w-auto d-flex align-items-center justify-content-center text-decoration-none"
        >
          {cat.title}
        </a>
      </div>
    ))}
  </Slider>
</div>


  <footer
        className="footer-navbar d-md-none fixed-bottom bg-primary text-white py-2"
        style={{ zIndex: 999 }}
      >
        {/* Scroll to Top */}
<div
  className="text-white text-center text-decoration-none"
  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
  style={{
    background: "#fff",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
    bottom: "70px",
    position: "fixed",
    right: "20px",
  }}
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="black"
    className="bi bi-arrow-up"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 12a.5.5 0 0 0 .5-.5V3.707l3.147 3.147a.5.5 0 0 0 .708-.708l-4-4-.007-.007a.498.498 0 0 0-.7.014l-4 4a.5.5 0 0 0 .708.708L7.5 3.707V11.5A.5.5 0 0 0 8 12z"
    />
  </svg>
</div>

        <div className="container-fluid">
          <div className="d-flex justify-content-around align-items-center">

            {/* Home */}
            <Link to="/" className="text-white text-center text-decoration-none">
              <img src={homeLogo} alt="home" style={{ width: "30px" }} />
            </Link>

            {/* Categories */}
            <Link to="/product" className="text-white text-center">
              <img src={menu} alt="menu" style={{ width: "30px" }} />
            </Link>

            {/* Wishlist */}
            {authState?.user ? <Link to="/wishlist" className="text-white text-center text-decoration-none">
              <img src={wishlist} alt="wishlist" style={{ width: "30px" }} />
                <span className="badge bg-white text-dark">
                {wishlistState?.length || 0}
              </span>
            </Link> :
            
        //     <div role="button" className="text-white text-center text-decoration-none"  data-bs-toggle="modal"
        // data-bs-target="#loginSignUpModal">
        //       <img src={wishlist} alt="wishlist" style={{ width: "30px" }} />
        //         <span className="badge bg-white text-dark">
        //         {0}
        //       </span>
        //     </div>
            <Link data-bs-toggle="modal"
        data-bs-target="#loginSignUpModal"  className="text-white text-center text-decoration-none">
              <img src={wishlist} alt="wishlist" style={{ width: "30px" }} />
                <span className="badge bg-white text-dark">
                {wishlistState?.length || 0}
              </span>
            </Link>
            }

            {/* Cart */}
           {authState?.user ?  <Link to="/cart" className="text-white text-center text-decoration-none">
              <img src={cart} alt="cart" style={{ width: "30px" }} />
                <span className="badge bg-white text-dark">
                  {cartState?.length || 0}
                </span>
            </Link> : <Link data-bs-toggle="modal"
        data-bs-target="#loginSignUpModal"  className="text-white text-center text-decoration-none">
              <img src={cart} alt="cart" style={{ width: "30px" }} />
                <span className="badge bg-white text-dark">
                {cartState?.length || 0}
              </span>
            </Link>
            }

            {/* Profile (Triggers Modal) */}
            <Link role="anchor"
    className="text-white text-center text-decoration-none"
              onClick={() => setIsModalOpen(true)}
              style={{ cursor: "pointer" }}
            >
              <img src={user} alt="user" style={{ width: "30px" }} />
            </Link>

          </div>
        </div>
      </footer>

      {/* Modal with Bootstrap class, conditionally rendered */}
      {isModalOpen && (
        <>
          <div className="modal fade show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content bg-white text-dark">
                <div className="modal-header">
                 {authState?.user ? (
                  <h5 className="modal-title">
                    {authState?.user ? `Welcome, ${authState.user.firstname}` : "Login Required"}
                  </h5>
                ) : (
                  <h5 className="modal-title" data-bs-toggle="modal"
  data-bs-target="#loginSignUpModal">Login Required</h5>
                )}
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsModalOpen(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  {authState?.user ? (
                    <div className="d-flex flex-column gap-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => {
                          setIsModalOpen(false);
                          navigate("/my-profile");
                        }}
                      >
                        My Profile
                      </button>
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => {
                          setIsModalOpen(false);
                          navigate("/my-orders");
                        }}
                      >
                        My Orders
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => {
                          setIsModalOpen(false);
                          handleLogout();
                        }}
                      >
                        Logout
                      </button>
                    </div>
                  ) : (
                    <div className="text-center">
                      <button
                        className="btn btn-primary"
                       data-bs-toggle="modal"
  data-bs-target="#loginSignUpModal"
                      >
                        Login
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Backdrop */}
          <div className="modal-backdrop fade show"></div>
        </>
      )}
<LoginSignUpModal />

    </>
  );
};

export default Header;
